import axios from 'axios';
import BaseApi from './base/BaseApi';

export default class FileApi extends BaseApi {
  static entityName = 'files';

  create(file, progressCallback = null, abortController = null) {
    const iri = this.getIri();

    const formData = new FormData();
    formData.append('file', file, file.name);

    return axios.post(iri, formData, {
      signal: abortController.signal,
      onUploadProgress: (progressEvent) => {
        if (progressCallback) {
          const progress = progressEvent.loaded / progressEvent.total;
          progressCallback(progress * 100);
        }
      },
    });
  }

  /**
   * (Claude) Загрузка файла модуля «Спецификации и комплектация» (ТЗ 9.1, 12.3): тот же
   * POST /api/files, но с назначением «спецификация» — такие файлы не учитываются в лимите
   * хранилища и выдаются по правам модуля. Ответ — сущность файла.
   */
  createForSpecification(file) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('purpose', 'specification');

    return axios.post(this.getIri(), formData).then((r) => r.data);
  }
}
